"use strict";

/*==============================================================================*
*TRESTLE™ W004
*POPUP TOOL — HORMONAL WELLNESS
*==============================================================================*/

window.TRESTLE_W004_TOOLS =
window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.hormonal = {


/*==============================================================================*
*RENDER
*==============================================================================*/

render(){

    return `

    <div class="tr-w004-hormonal-tool">

        <div class="diafemme-hormonal-tool">


            <!--==============================================================
            TABS
            ===============================================================-->

            <div class="hormonal-tab-buttons">


                <button
                type="button"
                class="hormonal-tab-btn active"
                data-hormonal-tab="menopause">

                    Menopause Score

                </button>


                <button
                type="button"
                class="hormonal-tab-btn"
                data-hormonal-tab="cycle">

                    Cycle Tracker

                </button>


                <button
                type="button"
                class="hormonal-tab-btn"
                data-hormonal-tab="pcos">

                    PCOS Risk

                </button>


                <button
                type="button"
                class="hormonal-tab-btn"
                data-hormonal-tab="thyroid">

                    Thyroid Tracker

                </button>


            </div>


            <!--==============================================================
            MENOPAUSE SCORE
            ===============================================================-->

            <div
            class="hormonal-tab-content active"
            data-hormonal-content="menopause">


                <h3>
                    Menopause Symptom Score
                </h3>


                <p class="hormonal-intro">

                    Rate the severity of common menopause symptoms.

                </p>


                <p class="hormonal-scale">

                    0 = None &nbsp; | &nbsp; 3 = Severe

                </p>


                <form data-hormonal-menopause-form>


                    ${this.renderSeverityRow("Hot Flashes")}

                    ${this.renderSeverityRow("Night Sweats")}

                    ${this.renderSeverityRow("Sleep Disturbances")}

                    ${this.renderSeverityRow("Mood Swings")}

                    ${this.renderSeverityRow("Fatigue")}

                    ${this.renderSeverityRow("Vaginal Dryness")}


                    <div class="hormonal-button-row">


                        <button
                        type="button"
                        class="hormonal-primary-btn"
                        data-menopause-calculate>

                            Calculate

                        </button>


                        <button
                        type="reset"
                        class="hormonal-secondary-btn"
                        data-menopause-clear>

                            Clear

                        </button>


                    </div>


                </form>


                <div
                class="hormonal-result"
                data-menopause-result
                hidden>
                </div>


            </div>


            <!--==============================================================
            CYCLE TRACKER
            ===============================================================-->

            <div
            class="hormonal-tab-content"
            data-hormonal-content="cycle">


                <h3>

                    Menstrual Cycle & Ovulation Tracker

                </h3>


                <label class="hormonal-label">

                    First Day of Last Period

                </label>


                <input
                type="date"
                class="hormonal-input"
                data-cycle-last-period>


                <label class="hormonal-label">

                    Average Cycle Length (days)

                </label>


                <input
                type="number"
                min="21"
                max="40"
                placeholder="28"
                class="hormonal-input"
                data-cycle-length>


                <div class="hormonal-button-row">


                    <button
                    type="button"
                    class="hormonal-primary-btn"
                    data-cycle-calculate>

                        Calculate

                    </button>


                    <button
                    type="button"
                    class="hormonal-secondary-btn"
                    data-cycle-clear>

                        Clear

                    </button>


                </div>


                <div
                class="hormonal-result"
                data-cycle-result
                hidden>
                </div>


            </div>


            <!--==============================================================
            PCOS RISK
            ===============================================================-->

            <div
            class="hormonal-tab-content"
            data-hormonal-content="pcos">


                <h3>

                    PCOS Risk Indicator

                </h3>


                <form data-hormonal-pcos-form>


                    ${this.renderYesNoRow("Irregular Periods")}

                    ${this.renderYesNoRow("Excess Hair Growth")}

                    ${this.renderYesNoRow("Weight Gain")}

                    ${this.renderYesNoRow("Acne / Oily Skin")}

                    ${this.renderYesNoRow("Thinning Hair")}

                    ${this.renderYesNoRow("Mood Swings")}


                    <div class="hormonal-button-row">


                        <button
                        type="button"
                        class="hormonal-primary-btn"
                        data-pcos-calculate>

                            Check Risk

                        </button>


                        <button
                        type="reset"
                        class="hormonal-secondary-btn"
                        data-pcos-clear>

                            Clear

                        </button>


                    </div>


                </form>


                <div
                class="hormonal-result"
                data-pcos-result
                hidden>
                </div>


            </div>


            <!--==============================================================
            THYROID TRACKER
            ===============================================================-->

            <div
            class="hormonal-tab-content"
            data-hormonal-content="thyroid">


                <h3>

                    Thyroid Symptom Tracker

                </h3>


                <form data-hormonal-thyroid-form>


                    ${this.renderSeverityRow("Fatigue")}

                    ${this.renderSeverityRow("Cold / Heat Sensitivity")}

                    ${this.renderSeverityRow("Unexplained Weight Changes")}

                    ${this.renderSeverityRow("Dry Skin / Hair Thinning")}

                    ${this.renderSeverityRow("Irregular Periods")}

                    ${this.renderSeverityRow("Mood Changes")}

                    ${this.renderSeverityRow("Brain Fog")}


                    <div class="hormonal-button-row">


                        <button
                        type="button"
                        class="hormonal-primary-btn"
                        data-thyroid-calculate>

                            Calculate

                        </button>


                        <button
                        type="reset"
                        class="hormonal-secondary-btn"
                        data-thyroid-clear>

                            Clear

                        </button>


                    </div>


                </form>


                <div
                class="hormonal-result"
                data-thyroid-result
                hidden>
                </div>


            </div>


            <!--==============================================================
            ABOUT
            ===============================================================-->

            <div class="hormonal-about">


                <h3>

                    About These Hormonal Wellness Calculators

                </h3>


                <p>

                    Hormonal balance plays an important role in women’s overall
                    health, influencing metabolism, menstrual cycles, mood
                    regulation, and long-term metabolic wellbeing.

                </p>


                <p>

                    These tools provide educational insights and should not be
                    used as medical diagnosis tools. Always consult a qualified
                    healthcare professional for personalised health advice.

                </p>


            </div>


        </div>

    </div>

    `;

},


/*==============================================================================*
*SEVERITY ROW
*==============================================================================*/

renderSeverityRow(label){

    return `

    <div class="hormonal-symptom">


        <span>

            ${label}

        </span>


        <select data-score-select>

            <option value="0">
                0
            </option>

            <option value="1">
                1
            </option>

            <option value="2">
                2
            </option>

            <option value="3">
                3
            </option>

        </select>


    </div>

    `;

},


/*==============================================================================*
*YES / NO ROW
*==============================================================================*/

renderYesNoRow(label){

    return `

    <div class="hormonal-symptom">


        <span>

            ${label}

        </span>


        <select data-score-select>

            <option value="0">
                No
            </option>

            <option value="1">
                Yes
            </option>

        </select>


    </div>

    `;

},


/*==============================================================================*
*INIT
*==============================================================================*/

init(root){

    if(!root){

        return;

    }


/*==============================================================================*
*TABS
*==============================================================================*/

    const tabButtons =

        root.querySelectorAll(

            "[data-hormonal-tab]"

        );


    const tabContents =

        root.querySelectorAll(

            "[data-hormonal-content]"

        );


    tabButtons.forEach(

        (button)=>{

            button.addEventListener(

                "click",

                ()=>{

                    const tab =

                        button.dataset.hormonalTab;


                    tabButtons.forEach(

                        (item)=>{

                            item.classList.remove(

                                "active"

                            );

                        }

                    );


                    tabContents.forEach(

                        (item)=>{

                            item.classList.remove(

                                "active"

                            );

                        }

                    );


                    button.classList.add(

                        "active"

                    );


                    const selected =

                        root.querySelector(

                            `[data-hormonal-content="${tab}"]`

                        );


                    if(selected){

                        selected.classList.add(

                            "active"

                        );

                    }

                }

            );

        }

    );


/*==============================================================================*
*HELPERS
*==============================================================================*/

    const sumScores = (container)=>{

        return Array.from(

            container.querySelectorAll(

                "[data-score-select]"

            )

        ).reduce(

            (total,select)=>{

                return total +

                    (

                        parseInt(

                            select.value,

                            10

                        ) || 0

                    );

            },

            0

        );

    };


    const clearResult = (result)=>{

        if(!result){

            return;

        }


        result.innerHTML = "";

        result.hidden = true;

    };


/*==============================================================================*
*MENOPAUSE SCORE
*==============================================================================*/

    const menopauseForm =

        root.querySelector(

            "[data-hormonal-menopause-form]"

        );


    const menopauseCalculate =

        root.querySelector(

            "[data-menopause-calculate]"

        );


    const menopauseClear =

        root.querySelector(

            "[data-menopause-clear]"

        );


    const menopauseResult =

        root.querySelector(

            "[data-menopause-result]"

        );


    if(

        menopauseForm &&
        menopauseCalculate &&
        menopauseResult

    ){

        menopauseCalculate.addEventListener(

            "click",

            ()=>{

                const total =

                    sumScores(

                        menopauseForm

                    );


                let message = "";


                if(total <= 5){

                    message =

                        "Mild symptoms. Lifestyle adjustments may help.";

                }

                else if(total <= 10){

                    message =

                        "Moderate symptoms. Consider discussing with a healthcare provider.";

                }

                else{

                    message =

                        "Severe symptoms. Medical consultation recommended.";

                }


                menopauseResult.innerHTML = `

                    <h4>

                        Menopause Symptom Score

                    </h4>


                    <div class="hormonal-score">

                        ${total} / 18

                    </div>


                    <p>

                        ${message}

                    </p>

                `;


                menopauseResult.hidden = false;

            }

        );

    }


    if(menopauseClear){

        menopauseClear.addEventListener(

            "click",

            ()=>{

                clearResult(

                    menopauseResult

                );

            }

        );

    }


/*==============================================================================*
*CYCLE TRACKER
*==============================================================================*/

    const cycleDate =

        root.querySelector(

            "[data-cycle-last-period]"

        );


    const cycleLength =

        root.querySelector(

            "[data-cycle-length]"

        );


    const cycleCalculate =

        root.querySelector(

            "[data-cycle-calculate]"

        );


    const cycleClear =

        root.querySelector(

            "[data-cycle-clear]"

        );


    const cycleResult =

        root.querySelector(

            "[data-cycle-result]"

        );


    if(

        cycleDate &&
        cycleLength &&
        cycleCalculate &&
        cycleResult

    ){

        cycleCalculate.addEventListener(

            "click",

            ()=>{

                const lastPeriod =

                    new Date(

                        cycleDate.value

                    );


                const length =

                    parseInt(

                        cycleLength.value,

                        10

                    );


                if(

                    isNaN(

                        lastPeriod.getTime()

                    ) ||

                    isNaN(

                        length

                    )

                ){

                    alert(

                        "Please enter valid inputs."

                    );

                    return;

                }


                const next =

                    new Date(

                        lastPeriod

                    );


                next.setDate(

                    lastPeriod.getDate() +

                    length

                );


                const ovulation =

                    new Date(

                        lastPeriod

                    );


                ovulation.setDate(

                    lastPeriod.getDate() +

                    length -

                    14

                );


                const fertileStart =

                    new Date(

                        ovulation

                    );


                fertileStart.setDate(

                    ovulation.getDate() -

                    4

                );


                const fertileEnd =

                    new Date(

                        ovulation

                    );


                fertileEnd.setDate(

                    ovulation.getDate() +

                    1

                );


                const formatDate = (date)=>{

                    return date.toLocaleDateString(

                        undefined,

                        {

                            day:"numeric",

                            month:"short"

                        }

                    );

                };


                cycleResult.innerHTML = `

                    <h4>

                        Estimated Cycle Dates

                    </h4>


                    <p>

                        <strong>
                            Next Period:
                        </strong>

                        ${formatDate(next)}

                    </p>


                    <p>

                        <strong>
                            Estimated Ovulation:
                        </strong>

                        ${formatDate(ovulation)}

                    </p>


                    <p>

                        <strong>
                            Fertile Window:
                        </strong>

                        ${formatDate(fertileStart)}
                        –
                        ${formatDate(fertileEnd)}

                    </p>

                `;


                cycleResult.hidden = false;

            }

        );

    }


    if(cycleClear){

        cycleClear.addEventListener(

            "click",

            ()=>{

                cycleDate.value = "";

                cycleLength.value = "";

                clearResult(

                    cycleResult

                );

            }

        );

    }


/*==============================================================================*
*PCOS RISK
*==============================================================================*/

    const pcosForm =

        root.querySelector(

            "[data-hormonal-pcos-form]"

        );


    const pcosCalculate =

        root.querySelector(

            "[data-pcos-calculate]"

        );


    const pcosClear =

        root.querySelector(

            "[data-pcos-clear]"

        );


    const pcosResult =

        root.querySelector(

            "[data-pcos-result]"

        );


    if(

        pcosForm &&
        pcosCalculate &&
        pcosResult

    ){

        pcosCalculate.addEventListener(

            "click",

            ()=>{

                const score =

                    sumScores(

                        pcosForm

                    );


                let message = "";


                if(score <= 1){

                    message =

                        "Low risk indicators.";

                }

                else if(score <= 3){

                    message =

                        "Moderate risk indicators. Consider a health checkup.";

                }

                else{

                    message =

                        "High risk indicators. Consulting a gynecologist may be helpful.";

                }


                pcosResult.innerHTML = `

                    <h4>

                        PCOS Risk Indicator

                    </h4>


                    <div class="hormonal-score">

                        ${score} / 6

                    </div>


                    <p>

                        ${message}

                    </p>

                `;


                pcosResult.hidden = false;

            }

        );

    }


    if(pcosClear){

        pcosClear.addEventListener(

            "click",

            ()=>{

                clearResult(

                    pcosResult

                );

            }

        );

    }


/*==============================================================================*
*THYROID TRACKER
*==============================================================================*/

    const thyroidForm =

        root.querySelector(

            "[data-hormonal-thyroid-form]"

        );


    const thyroidCalculate =

        root.querySelector(

            "[data-thyroid-calculate]"

        );


    const thyroidClear =

        root.querySelector(

            "[data-thyroid-clear]"

        );


    const thyroidResult =

        root.querySelector(

            "[data-thyroid-result]"

        );


    if(

        thyroidForm &&
        thyroidCalculate &&
        thyroidResult

    ){

        thyroidCalculate.addEventListener(

            "click",

            ()=>{

                const score =

                    sumScores(

                        thyroidForm

                    );


                let message = "";


                if(score <= 4){

                    message =

                        "Minimal symptoms.";

                }

                else if(score <= 10){

                    message =

                        "Possible thyroid imbalance indicators.";

                }

                else{

                    message =

                        "Multiple symptoms present. A thyroid test may be advisable.";

                }


                thyroidResult.innerHTML = `

                    <h4>

                        Thyroid Symptom Score

                    </h4>


                    <div class="hormonal-score">

                        ${score} / 21

                    </div>


                    <p>

                        ${message}

                    </p>

                `;


                thyroidResult.hidden = false;

            }

        );

    }


    if(thyroidClear){

        thyroidClear.addEventListener(

            "click",

            ()=>{

                clearResult(

                    thyroidResult

                );

            }

        );

    }

}

};